<template>
  <div v-if="!store.loading && !store.error">
    <v-list lines="two">
      <v-list-item>
        <v-list-item-title class="spread">
          <div>{{ store.data?.KundenNr }}</div>
          <div>
            <div v-if="store.data?.DebitorKto > 0">{{ store.data?.DebitorKto }}</div>
            <div v-if="store.data?.KreditorKto > 0">{{ store.data?.KreditorKto }}</div>
          </div>
        </v-list-item-title>
        <v-list-item-subtitle class="spread">
          <div>{{ detailTyp }}</div>
          <div>
            <div v-if="store.data?.DebitorKto > 0">Debitoren-Konto</div>
            <div v-if="store.data?.KreditorKto > 0">Kreditoren-Konto</div>
          </div>
        </v-list-item-subtitle>
      </v-list-item>
      <v-divider/>
      <div v-for="address in store.data?.PostAnschrift"
           :key="`${address.KundenNr}${address.Plz}${address.Ort}${address.Strasse}${address.Number}`">
        <v-list-item v-if="address.Strasse" link
                     :href="`https://maps.google.com/?saddr=My+Location&daddr==${address.Strasse}, ${address.Plz} ${address.Ort}`"
                     target="_blank">
          <template #prepend>
            <v-icon>mdi-map-marker</v-icon>
          </template>

          <v-list-item-title>{{ address.Strasse }}</v-list-item-title>
          <v-list-item-subtitle>{{
              `${address.Plz} ${address.Ort}`
            }}
          </v-list-item-subtitle>

        </v-list-item>
        <v-list-item v-if="address.Telefon1" link :href="`tel: '${address.Telefon1}'`">
          <template #prepend>
            <v-icon>mdi-phone</v-icon>
          </template>

          <v-list-item-title>{{ address.Telefon1 }}</v-list-item-title>

        </v-list-item>
        <v-list-item v-if="address.Telefon2" link :href="`tel: '${address.Telefon2}'`">
          <template #prepend>
            <v-icon>mdi-phone</v-icon>
          </template>

          <v-list-item-title>{{ address.Telefon2 }}</v-list-item-title>

        </v-list-item>
        <v-list-item v-if="address.Email" link :href="`mailto: '${address.Email}'`">
          <template #prepend>
            <v-icon>mdi-at</v-icon>
          </template>

          <v-list-item-title>{{ address.Email }}</v-list-item-title>

        </v-list-item>
        <v-list-item v-if="address.Homepage" link :href="`https://${address.Homepage}`" target="_blank">
          <template #prepend>
            <v-icon>mdi-web</v-icon>
          </template>

          <v-list-item-title>{{ address.Homepage }}</v-list-item-title>

        </v-list-item>
        <v-divider></v-divider>
      </div>
      <v-list-item link :to="{
          name: 'customer_contacts_list',
          params: { id: store.data?.KundenNr.toString(), name: store.data?.Kundname },
        }">
        <template #prepend>
          <v-avatar size="32px" color="primary">
            <v-icon color="white" size="18px">mdi-account-group</v-icon>
          </v-avatar>
        </template>

        <v-list-item-title>Ansprechpartner</v-list-item-title>

        <template #append>
          <v-list-item-action>
            <v-icon>mdi-arrow-right</v-icon>
          </v-list-item-action>
        </template>
      </v-list-item>

      <v-list-item link :to="{
          name: 'customer_documents',
          params: { id: store.data?.KundenNr.toString(), name: store.data?.Kundname },
        }">
        <template #prepend>
          <v-avatar size="32px" color="primary">
            <v-icon color="white" size="18px">mdi-receipt-text</v-icon>
          </v-avatar>
        </template>

        <v-list-item-title>Dokumente</v-list-item-title>

        <template #append>
          <v-list-item-action>
            <v-icon>mdi-arrow-right</v-icon>
          </v-list-item-action>
        </template>
      </v-list-item>
      <v-list-item link :to="{
          name: 'contact_histories_list',
          params: { id: store.data?.KundenNr.toString(), name: store.data?.Kundname },
        }">
        <template #prepend>
          <v-avatar size="32px" color="primary">
            <v-icon color="white" size="18px">mdi-file-document-check</v-icon>
          </v-avatar>
        </template>

        <v-list-item-title>Kontakte</v-list-item-title>

        <template #append>
          <v-list-item-action>
            <v-icon>mdi-arrow-right</v-icon>
          </v-list-item-action>
        </template>
      </v-list-item>
    </v-list>

    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-title>
          Vorgänge
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-list lines="two">
            <template
              v-if="store.data?.KundStatus == ProviderStatus.Kunden || store.data?.KundStatus == ProviderStatus.Interessenten">
              <v-list-item link :to="{
                      name: 'customer_offers_module',
                      params: { id: store.data?.KundenNr.toString(), name: store.data?.Kundname },
                    }">
                <template #prepend>
                  <v-avatar size="32px" color="primary">
                    <v-icon color="white" size="18px">mdi-file-document</v-icon>
                  </v-avatar>
                </template>

                <v-list-item-title>Angebote</v-list-item-title>

                <template #append>
                  <v-list-item-action>
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>
              <v-list-item link :to="{
                      name: 'customer_tasks_module',
                      params: { id: store.data?.KundenNr.toString(), name: store.data?.Kundname },
                    }">
                <template #prepend>
                  <v-avatar size="32px" color="primary">
                    <v-icon color="white" size="18px">mdi-file-document-check</v-icon>
                  </v-avatar>
                </template>

                <v-list-item-title>Aufträge</v-list-item-title>

                <template #append>
                  <v-list-item-action>
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </template>
            <template v-if="store.data?.KundStatus == ProviderStatus.Kunden">
              <v-list-item link :to="{
                      name: 'customer_delivery_notes_module',
                      params: { id: store.data?.KundenNr.toString(), name: store.data?.Kundname },
                    }">
                <template #prepend>
                  <v-avatar size="32px" color="primary">
                    <v-icon color="white" size="18px">mdi-truck-check</v-icon>
                  </v-avatar>
                </template>

                <v-list-item-title>Lieferscheine</v-list-item-title>

                <template #append>
                  <v-list-item-action>
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>
              <v-list-item link :to="{
                      name: 'customer_bills_module',
                      params: { id: store.data?.KundenNr.toString(), name: store.data?.Kundname },
                    }">
                <template #prepend>
                  <v-avatar size="32px" color="primary">
                    <v-icon color="white" size="18px">mdi-receipt-text</v-icon>
                  </v-avatar>
                </template>

                <v-list-item-title>Rechnungen</v-list-item-title>

                <template #append>
                  <v-list-item-action>
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </template>
            <template v-if="store.data?.KundStatus == ProviderStatus.Lieferanten">
              <v-list-item link :to="{
                      name: 'customer_orders_module',
                      params: { id: store.data?.KundenNr.toString(), name: store.data?.Kundname },
                    }">
                <template #prepend>
                  <v-avatar size="32px" color="primary">
                    <v-icon color="white" size="18px">mdi-receipt-text</v-icon>
                  </v-avatar>
                </template>

                <v-list-item-title>Bestellungen</v-list-item-title>

                <template #append>
                  <v-list-item-action>
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </template>
          </v-list>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

  </div>
  <error v-else :module="store.$id"/>
</template>
<script setup lang="ts">
import Error from '@/components/Error.vue';
import {ProviderStatus} from '@/model/Provider';
import {useStorage} from '@/composables/storage';
import useDetailProviderStore from '@/store/detailProvider';
import {computed} from 'vue';

const store = useDetailProviderStore();
useStorage(
    store,
    (customer) => (customer?.Kundname ? customer.Kundname : 'Firmendetail'),
    (route) => {
      return {KundenNr: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id)};
    },
);


const detailTyp = computed(() => {
  switch (store.data?.GroupName) {
    case 'Lieferant':
      return 'Lieferanten-Nr.';
    default:
      return 'Kunden-Nr.';
  }
});

defineExpose({
  Error,
  ProviderStatus,
  store,
  detailTyp,
});
</script>
